<div class="modal-header">
    <h4 class="modal-title">Informations du voucher</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p *ngIf="intro">{{ intro }}</p>

    <form [formGroup]="professionalForm">

        <fieldset class="mb-4">
            <legend class="col-form-label font-weight-bold">Dossier</legend>

            <div class="form-group">
                <label for="voucherFileNumber">Numéro de dossier</label>
                <input type="text" class="form-control" id="voucherFileNumber" formControlName="file_number">
            </div>

            <div class="form-group">
                <label>Centre de formation</label>
                <input type="text" class="form-control" [value]="exam.exam_center?.nom || '—'" disabled>
            </div>
        </fieldset>

        <fieldset>
            <legend class="col-form-label font-weight-bold">Situation professionnelle</legend>

            <div class="form-group">
                <label for="voucherQualificationLevel">Niveau de qualification</label>
                <app-suggestion-select formControlName="qualification_level" category="qualification_level"
                    inputId="voucherQualificationLevel"></app-suggestion-select>
            </div>

            <div class="form-group">
                <label>Métier exercé</label>
                <app-suggestion-checklist formControlName="profession" category="profession"></app-suggestion-checklist>
            </div>

            <div class="form-group">
                <label for="voucherObjective">Objectif poursuivi</label>
                <app-suggestion-select formControlName="objective" category="objective"
                    inputId="voucherObjective"></app-suggestion-select>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.dismiss()"
        [disabled]="submitting">Annuler</button>
    <button type="button" class="btn btn-outline-success" (click)="validate()"
        [disabled]="professionalForm.invalid || submitting">
        <span *ngIf="submitting" class="button-loader"></span>
        Valider
    </button>
</div>
